import Dialog from '@components/Atoms/Dialog';
import { Typography } from '@mui/material';
import React from 'react';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string | React.ReactNode;
}

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
}: ConfirmDialogProps) => (
  <Dialog
    title={title || 'Please Confirm'}
    open={isOpen}
    onClose={() => onClose()}
    actions={[
      {
        label: 'Yes, I am sure',
        onClick: () => onConfirm(),
        buttonProps: {
          variant: 'contained',
          color: 'error',
          sx: {
            minWidth: '100px',
          },
        },
      },
      {
        label: 'Cancel',
        onClick: () => onClose(),
        buttonProps: {
          variant: 'contained',
          color: 'primary',
          sx: {
            minWidth: '100px',
          },
        },
      },
    ]}
  >
    <Typography
      component="div"
      variant="body2"
      sx={{
        marginBottom: '16px',
      }}
    >
      {message || 'Are you sure you want to proceed?'}
    </Typography>
  </Dialog>
);

export default ConfirmDialog;
